import { inject, Injectable, Pipe, PipeTransform } from '@angular/core';
import { COUNTRY_CODE } from '@core/enums';
import { GetCountryService } from '@core/services';

@Injectable({
  providedIn: 'root'
})
@Pipe({
  name: 'osrCurrency',
  standalone: true,
})
export class CurrencyOSRPipe implements PipeTransform {
  readonly #getCountryService = inject(GetCountryService);
  codeCountry = '';
  withDecimals = false;

  #getCurrencyConfig(): IconfigCurrency {
    switch (this.#getCountryService.getCountry()) {
      case COUNTRY_CODE.BRAZIL:
        this.codeCountry = 'BRL';
        this.withDecimals = true;
        break;
      case COUNTRY_CODE.ARGENTINA:
        this.codeCountry = 'ARS';
        break;
      case COUNTRY_CODE.CHILE:
        this.codeCountry = 'CLP';
        break;
      case COUNTRY_CODE.COLOMBIA:
        this.codeCountry = 'COP';
        break;
      case COUNTRY_CODE.ECUADOR:
        this.codeCountry = 'USD';
        this.withDecimals = true;
        break;
      case COUNTRY_CODE.VENEZUELA:
        this.codeCountry = 'VEF';
        break;
      case COUNTRY_CODE.PERU:
        this.codeCountry = 'PEN';
        this.withDecimals = true;
        break;
    }

    return {
      currency: this.codeCountry,
      maximumFractionDigits: this.withDecimals ? 2 : 0
    }
  }

  #getFormatedPrice(price: number, lang: string): string {
    const configCurrency = this.#getCurrencyConfig();

    if (!price || !lang) return '';

    const formattedValue = price.toLocaleString(lang, {
      style: 'currency',
      currency: configCurrency.currency,
      maximumFractionDigits: configCurrency.maximumFractionDigits,
    });
    return formattedValue;
  }

  transform(price: number | undefined, lang: string): string {
    if (!price) return '';
    return this.#getFormatedPrice(price, lang);
  }

}

interface IconfigCurrency {
  currency: string;
  maximumFractionDigits: number
}
